if (!customElements.get('countdown-date')) {
    customElements.define('countdown-date', class CountdownDate extends HTMLElement {
        constructor() {
            super();

            const resultPlace = this.querySelector('span');
            const deadLineTimeValue = this.getAttribute('data-deadline') || 0;
            const currentTimeValue = this.getAttribute('data-current-time') || 0;

            let deadLineTimeMs = new Date(deadLineTimeValue).getTime();
            let currentTimeInMs = new Date(currentTimeValue).getTime();

            const interval = setInterval(() => {
                currentTimeInMs += 1000;

                const timeRemaining = deadLineTimeMs - currentTimeInMs;
                var days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
                var hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

                let result = days + 'd ' + hours + 'h ' + minutes + 'm ' + seconds + 's';

                if (timeRemaining <= 0) {
                    clearInterval(interval);
                    result = '0d 0h 0m 0s'
                }

                resultPlace.innerHTML = result;
            }, 1000);
        }
    });
}
